import { Drawer } from '@photosi/rn-components/drawer/Drawer';
import { StackedDynamicModals } from '@photosi/rn-components/modals/stacked-dynamic-modals/StackedDynamicModals';
import { ToastSharePhotos } from '@photosi/rn-components/toast-share-photos/ToastSharePhotos';
import ToastWrapper from '@photosi/rn-components/toast/ToastWrapper';
import { observer } from 'mobx-react-lite';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { useStore } from 'src/contexts/StoreContext';
import { UploadPicker } from 'src/editor-v3/components/upload-picker/UploadPicker';
import { useAddToCartStatus } from 'src/hooks/useAddToCartStatus';
import { useAfterAppLoaded } from 'src/hooks/useAfterAppLoaded';
import { useEditorApp } from 'src/hooks/useEditorApp';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

const UploadV3 = observer(() => {
  useEditorApp();
  const { data, project } = useStore();
  const { isDesktop } = useResponsiveScreen();
  useAddToCartStatus();
  useAfterAppLoaded();
  return (
    <GestureHandlerRootView testID="root-gesture-handler" style={{ flex: 1 }}>
      {project?.activeProject && <UploadPicker />}
      <ToastWrapper />
      <StackedDynamicModals />
      <Drawer />
      {isDesktop && data.showNewImageNotification && <ToastSharePhotos />}
    </GestureHandlerRootView>
  );
});

export default UploadV3;
